<ll-titulo>Planificaciones Compartidas</ll-titulo>
<ng-container *ngIf="route.params | async as params">
    <planificacion-compartida-profesores
        [planificacionId]="+params['id']"
        [disableVerClaseButton]="disableVerClaseButton"
        [disableActualButton]="disableActualButton"
    ></planificacion-compartida-profesores>
</ng-container>
